export const PROJECT_NAME = 'RSlang'
export const PAGES = ['Домой', 'Учебник', 'Игры', 'Статистика', 'Об авторах']
// export const PAGES = ['Home', 'E-book', 'Games', 'Statistics', 'About']
export const ROUTES = ['', 'textbook', 'games', 'stats', 'about']
